if (!customElements.get("m-product-details-tabs")) {
  class MProductDetailsTabs extends HTMLElement {
    constructor() {
      super();
      this.tabs = new MinimogTheme.Tabs(this);

      this.initAccordion();

      if (Shopify.designMode) {
        document.addEventListener("shopify:block:select", (event) => {
          const tabHeader = event && event.target;
          const index = (tabHeader && Number(tabHeader.dataset.index)) || 0;
          this.tabs && this.tabs.setActiveTab(index);

          // Also reveal the matching accordion item on mobile
          const item = this.querySelector(
            '.m-tab-content[data-index="' + index + '"]'
          );
          if (item) this.openItem(item);
        });
      }
    }

    initAccordion() {
      this.querySelectorAll(".m-tab-content__toggle").forEach((toggle) => {
        const item = toggle.closest(".m-tab-content");
        if (!item) return;

        // Default-open items should start fully expanded
        const collapse = item.querySelector(".m-tab-content__collapse");
        if (collapse && item.classList.contains("is-open")) {
          collapse.style.height = "auto";
        }

        toggle.addEventListener("click", () => {
          if (item.classList.contains("is-open")) {
            this.closeItem(item);
          } else {
            this.openItem(item);
          }
        });
      });
    }

    openItem(item) {
      const collapse = item.querySelector(".m-tab-content__collapse");
      const toggle = item.querySelector(".m-tab-content__toggle");
      if (!collapse) return;

      item.classList.add("is-open");
      if (toggle) toggle.setAttribute("aria-expanded", "true");

      collapse.style.height = collapse.scrollHeight + "px";
      const onEnd = (event) => {
        if (event.propertyName !== "height") return;
        // Let the body grow/shrink freely once the animation is done
        if (item.classList.contains("is-open")) collapse.style.height = "auto";
        collapse.removeEventListener("transitionend", onEnd);
      };
      collapse.addEventListener("transitionend", onEnd);
    }

    closeItem(item) {
      const collapse = item.querySelector(".m-tab-content__collapse");
      const toggle = item.querySelector(".m-tab-content__toggle");
      if (!collapse) return;

      // Animate from the current pixel height down to 0
      collapse.style.height = collapse.scrollHeight + "px";
      // Force a reflow so the browser registers the starting height
      collapse.offsetHeight; // eslint-disable-line no-unused-expressions
      item.classList.remove("is-open");
      if (toggle) toggle.setAttribute("aria-expanded", "false");
      collapse.style.height = "0px";
    }
  }
  customElements.define("m-product-details-tabs", MProductDetailsTabs);
}
